module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-pinterest-2-254ae9d44c57ea1da44d12df3ff254f3.jpg";